import React from "react"

export interface OnClickLinkProps {
  onClick: () => void
}

const OnClickLink: React.FC<OnClickLinkProps> = props => (
  <a className="c-link has-pointer" href={null} onClick={props.onClick}>
    {props.children}
  </a>
)

export default OnClickLink
